// This JavaScript function saves the scroll position between page renders of each element with the
// "data-preserve-scroll" attribute.
// When the next page is renders, we restore the scroll position.
(() => {
  const scrollPositions: Record<string, number> = {}
  const saveScrollPositions = () => {
    document.querySelectorAll<HTMLElement>("[data-preserve-scroll]").forEach((el) => {
      if (el.id) scrollPositions[el.id] = el.scrollTop
    })
  }

  const restoreScrollPositions = () => {
    document.querySelectorAll<HTMLElement>("[data-preserve-scroll]").forEach((el) => {
      const saved = scrollPositions[el.id]
      if (saved !== undefined) el.scrollTop = saved
    })
  }

  addEventListener("turbo:before-cache", saveScrollPositions)
  addEventListener("turbo:render", restoreScrollPositions)
})()
